/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import { forwardRef, createElement } from 'react';
import { mergeClasses, toKebabCase } from './shared/src/utils.js';
import Icon from './Icon.js';
const createLucideIcon = (iconName, iconNode) => {
  const Component = forwardRef((_ref, ref) => {
    let {
      className,
      ...props
    } = _ref;
    return createElement(Icon, {
      ref,
      iconNode,
      className: mergeClasses(`lucide-${toKebabCase(iconName)}`, className),
      ...props
    });
  });
  Component.displayName = `${iconName}`;
  return Component;
};
export { createLucideIcon as default };